<div class="nav-item-options-menu" *ngIf="navItemOptions.options.length > 0">
  <ul class="nav-item-options">
    <li *ngFor="let option of navItemOptions.options" class="nav-item-options__item">
      <button class="nav-item-options__button" (click)="launchAction(option.action)">
        <ion-icon name="{{option.icon}}"></ion-icon>
        <span>{{option.title}}</span>
      </button>
    </li>
  </ul>
</div>